import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackInternalEvent } from '@src/telemetry/track'

import { customerServiceClient } from '../../utils/HttpClient'

export const syncCustomAttributes = async (email?: string) => {
  try {
    if (!email) {
      // @i18n-ignore
      throw new Error('Email not present in user currentAuthenticatedUser details, syncCustomAttributes() runtime')
    }
    const params = new URLSearchParams({
      email: email,
    })
    await customerServiceClient.put(`/sync-custom-attributes?${params.toString()}`, {})
    return true
  } catch (error) {
    trackInternalEvent(TELEMETRY_EVENT_NAMES.CUSTOMER_ID_SYNC_ERROR, {
      // @i18n-ignore
      message: 'Failed to sync user attributes',
      email: email,
    })
    return false
  }
}

export const updateCustomerName = async (firstName: string, lastName: string, customerId: string) => {
  try {
    if (!firstName || !lastName) {
      // @i18n-ignore
      throw new Error('First name or last name is missing, updateCustomerName() runtime')
    }

    const resp = await customerServiceClient.put(`/customer-name/${customerId}`, {
      firstName,
      lastName,
    })

    return resp
  } catch (error) {
    console.error(error)
    throw error
  }
}
